export enum StatusConta {
	AGUARDANDO_PAGAMENTO = <any>'conta:aguardando_pagamento',
	VENCIDO = <any>'conta:vencido',
	PAGO = <any>'conta:pago',
	PAGO_NA_PORTARIA = <any>'conta:pago_na_portaria',
	CANCELADO = <any>'conta:cancelado',
	DEVOLVIDO = <any>'conta:devolvido'
}
